import * as Yup from "yup"

export default function validation_staff_id_selector(field, acc) {
  const { field_name, field_validation } = field

  const checkBool = () => {
    if (!field_validation.required) return false
    return field_validation.required[0] === "true"
  }

  const isRequired = checkBool()
  const isRequiredTxt =
    (field_validation.required && field_validation.required[1]) ||
    "Required field."

  if (!isRequired) return acc

  return {
    [field_name]: Yup.object()
      .shape({
        key: Yup.string(),
        label: Yup.string()
      })
      .typeError(isRequiredTxt) // when value is not an object
      .required(isRequiredTxt) // when the whole value is missing/null
      .test(
        "staff-id-selector-required-fields",
        isRequiredTxt,
        function (value) {
          if (!value) return this.createError({ message: isRequiredTxt })
          const keyMissing =
            typeof value.key !== "string" || value.key.trim().length === 0
          const labelMissing =
            typeof value.label !== "string" || value.label.trim().length === 0
          if (keyMissing || labelMissing) {
            return this.createError({ message: isRequiredTxt })
          }
          return true
        }
      ),
    ...acc,
  }
}